'use client';

import useClientErrorLogging from '../hooks/useClientErrorLogging';

export default function ClientErrorLogger() {
  useClientErrorLogging();
  return null;
}
